import { useMemo, useState } from "react";
import { Select } from "../ui";

const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

// The offered programme a per-programme tab shows; the first one until another is chosen
export function useOfferedProgramme(scholarship) {
  const programmes = useMemo(() => scholarship.programmes ?? [], [scholarship.programmes]);
  const [programmeId, setProgrammeId] = useState(programmes[0]?.id ?? "");
  const programme = programmes.find((p) => p.id === programmeId) ?? programmes[0];
  return { programmes, programme, choose: setProgrammeId };
}

/**
 * Chooses the offered programme (or, with another `label`, the level of study) to edit, each
 * labelled with how many of its `item`s (`countOf`) it has, and copies another one's set into the
 * edited one. Those with nothing to copy are left out of the copy list.
 */
export default function ProgrammePicker({ programmes, programme, onChange, countOf, item, items = `${item}s`, copyLabel, onCopy, disabled, label = "Programme" }) {
  const options = programmes.map((p) => ({ value: p.id, label: `${[p.name, p.institutionName].filter(Boolean).join(", ")} (${plural(countOf(p), item, items)})` }));
  const copyOptions = programmes.filter((p) => p.id !== programme.id && countOf(p) > 0).map((p) => ({ value: p.id, label: p.name }));

  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-end">
      <Select label={label} value={programme.id} onChange={(e) => onChange(e.target.value)} options={options} className="sm:flex-1" />
      {onCopy && copyOptions.length > 0 && (
        <Select
          label={copyLabel}
          placeholder={`Choose a ${label.toLowerCase()}`}
          value=""
          onChange={(e) => onCopy(programmes.find((p) => p.id === e.target.value))}
          options={copyOptions}
          disabled={disabled}
          className="sm:w-72"
        />
      )}
    </div>
  );
}
